import type { FlexProps } from '@mantine/core';
import { Flex, Space, Title } from '@mantine/core';

import styles from './ListContainer.module.css';

export const LBListContainer = ({
  children,
  label,
  ...props
}: FlexProps & { label?: string }) => (
  <Flex direction='column' {...props}>
    <Space h={16} />
    <Title order={4}>{label}</Title>
    <Space h={8} />
    <div className={styles.content}>{children}</div>
  </Flex>
);
